/*
 * Copyright (c) 2026. Orion Analytics
 */

import React, { useEffect, useState } from "react";
import {
    TrendingUp,
    TrendingDown,
    Activity
} from "lucide-react";

import {
    Sparklines,
    SparklinesLine
} from "react-sparklines";

import {
    fetchMarketMovers,
    fetchMarketMovers_sparkline
} from "../api";

export default function LiveMarketOverview() {

    const [indices, setIndices] = useState([]);
    const [sparklineData, setSparklineData] = useState({});

    useEffect(() => {

        loadIndices();

        const interval = setInterval(
            loadIndices,
            30000
        );

        return () => clearInterval(interval);

    }, []);

    useEffect(() => {

        loadSparklines();

        const interval = setInterval(
            loadSparklines,
            30000
        );

        return () => clearInterval(interval);

    }, []);

    const loadIndices = async () => {

        try {

            const data =
                await fetchMarketMovers("indices");

            setIndices(data.stocks || []);

        } catch (err) {

            console.error(err);

        }
    };

    const loadSparklines = async () => {

        try {

            const data =
                await fetchMarketMovers_sparkline(
                    "indices"
                );

            setSparklineData(data);

        } catch (err) {

            console.error(err);

        }
    };

    const getTextColor = (change) => {

        if (change > 0)
            return "text-emerald-600";

        if (change < 0)
            return "text-red-600";

        return "text-slate-500";
    };

    const getSparkColor = (change) => {

        if (change > 0)
            return "#10b981";

        if (change < 0)
            return "#ef4444";

        return "#64748b";
    };

    return (

        <section className="py-10">

            <div className="max-w-7xl mx-auto">

                <div className="flex items-center justify-between mb-6">

                    <div>

                        <div className="
                            text-sm
                            uppercase
                            tracking-widest
                            text-emerald-600
                            font-semibold
                        ">
                            Live Markets
                        </div>

                        {/*<h2 className="*/}
                        {/*    text-3xl*/}
                        {/*    font-bold*/}
                        {/*    text-slate-900*/}
                        {/*">*/}
                        {/*    Market Snapshot*/}
                        {/*</h2>*/}

                    </div>

                    <div className="
                        hidden
                        md:flex
                        items-center
                        gap-2
                        text-sm
                        text-slate-500
                    ">
                        <Activity size={16}/>
                        Updated Every 30 Seconds
                    </div>

                </div>

                <div className="
                    grid
                    grid-cols-1
                    md:grid-cols-2
                    xl:grid-cols-4
                    gap-6
                ">

                    {indices.map((index) => {

                        const positive =
                            index.change > 0;

                        return (

                            <div
                                key={index.symbol}
                                className="
                                    bg-white
                                    rounded-3xl
                                    border
                                    border-slate-200
                                    shadow-sm
                                    hover:shadow-lg
                                    transition-all
                                    p-6
                                "
                            >

                                <div className="
                                    flex
                                    justify-between
                                    items-start
                                ">

                                    <div>

                                        <div className="
                                            text-xs
                                            uppercase
                                            tracking-wide
                                            text-slate-500
                                            mb-2
                                        ">
                                            Index
                                        </div>

                                        <h3 className="
                                            text-lg
                                            font-bold
                                            text-slate-900
                                        ">
                                            {index.name}
                                        </h3>

                                    </div>

                                    <div
                                        className={`
                                            p-2
                                            rounded-xl
                                            ${
                                                positive
                                                ? "bg-emerald-50"
                                                : "bg-red-50"
                                            }
                                        `}
                                    >
                                        {positive ? (
                                            <TrendingUp
                                                size={18}
                                                className="
                                                    text-emerald-600
                                                "
                                            />
                                        ) : (
                                            <TrendingDown
                                                size={18}
                                                className="
                                                    text-red-600
                                                "
                                            />
                                        )}
                                    </div>

                                </div>

                                <div className="mt-5">

                                    <div className="
                                        text-3xl
                                        font-bold
                                        text-slate-900
                                    ">
                                        {Number(
                                            index.currentValue
                                        ).toLocaleString()}
                                    </div>

                                    <div
                                        className={`
                                            mt-2
                                            font-semibold
                                            ${getTextColor(
                                                index.change
                                            )}
                                        `}
                                    >
                                        {index.change > 0
                                            ? "+"
                                            : ""}
                                        {index.change}%

                                        <span className="ml-2">

                                            (
                                            {index.pointChange > 0
                                                ? "+"
                                                : ""}
                                            {Number(
                                                index.pointChange
                                            ).toFixed(2)}
                                            )

                                        </span>

                                    </div>

                                </div>

                                <div className="
                                    mt-5
                                    h-14
                                ">

                                    {sparklineData[
                                        index.name
                                    ] && (

                                        <Sparklines
                                            data={
                                                sparklineData[
                                                    index.name
                                                ].map(
                                                    (t) =>
                                                        t.last_price
                                                )
                                            }
                                            svgWidth={220}
                                            svgHeight={50}
                                        >

                                            <SparklinesLine
                                                color={getSparkColor(
                                                    index.change
                                                )}
                                            />

                                        </Sparklines>

                                    )}

                                </div>

                            </div>

                        );
                    })}

                </div>

            </div>

        </section>
    );
}